
import filters from "@/filters";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import { AxiosResponse } from "axios";
import { setToken } from "@/functions/token.function";
import toast from "@/functions/toast.function";
import { isEmail, isPhone } from "@/functions/global.function";
import { error } from "jquery";

@Component({
  components: {},
  filters,
})
export default class Register extends Vue {
  @Action("getSelf", { namespace: "auth" })
  private getSelf: any;
  @Action("register", { namespace: "auth" })
  private register: any;
  @Action("loginWithGoogle", { namespace: "auth" })
  private loginWithGoogle: any;
  @Action("sendRegisterOtp", { namespace: "auth" })
  private sendRegisterOtp: any;

  private partnerId = null;
  private name = "";
  private email = this.$route.query?.email
    ? this.$route.query?.email?.toString()
    : "";
  private phone = "+62";
  private password = "";
  private confirmPassword = "";
  private nameError = "";
  private emailError = "";
  private phoneError = "";
  private passwordError = "";
  private confirmPasswordError = "";
  private showPassword = false;
  private showConfirmPassword = false;

  private googleClientID: any = process.env.VUE_APP_GOOGLE_CLIENT_ID;

  private created() {
    this.setParams();
  }

  private setParams() {
    let params = this.$route.query?.params?.toString();
    let decoded = atob(params);
    try {
      let data = JSON.parse(decoded);
      this.partnerId = data.partner_id;
      this.name = data.name;
      this.email = data.email;
      this.phone = data.phone.replaceAll(" ", "").replace(/^0/, "+62");
    } catch (e) {
      toast.warning("Invalid parameters.");
    }
  }

  private togglePassword() {
    this.showPassword = !this.showPassword;
    const password = document.getElementById("password");
    password?.setAttribute("type", this.showPassword ? "text" : "password");
    password?.focus();
  }

  private toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
    const password = document.getElementById("confirm-password");
    password?.setAttribute(
      "type",
      this.showConfirmPassword ? "text" : "password"
    );
    password?.focus();
  }

  private onlyNumber(event: any) {
    let keyCode = event.keyCode ? event.keyCode : event.which;
    if (keyCode !== 43) {
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    }
  }

  private resetError() {
    this.nameError = "";
    this.emailError = "";
    this.phoneError = "";
    this.passwordError = "";
    this.confirmPasswordError = "";
  }

  private submit() {
    this.resetError();
    if (!this.name) {
      this.nameError = "The name field is required.";
      return false;
    }
    if (!this.email) {
      this.emailError = "The email field is required.";
      return false;
    }
    if (!isEmail(this.email)) {
      this.emailError = "The email field must be a valid email address.";
      return false;
    }
    if (!this.phone) {
      this.phoneError = "The phone field is required.";
      return false;
    }
    if (!isPhone(this.phone)) {
      this.phoneError =
        "The phone field must be a valid phone number. (e.g. +62812345678890)";
      return false;
    }
    // if (!this.password) {
    //   this.passwordError = "The password field is required.";
    //   return false;
    // }
    // if (!this.confirmPassword) {
    //   this.confirmPasswordError = "The confirm password field is required.";
    //   return false;
    // }
    // if (this.confirmPassword !== this.password) {
    //   this.confirmPasswordError =
    //     "The confirm password field must match password.";
    //   return false;
    // }
    this.register({
      params: {
        partner_id: this.partnerId,
        name: this.name,
        email: this.email,
        phone: this.phone,
        // password: this.password,
        // confirm_password: this.confirmPassword,
      },
      success: (response: AxiosResponse) => {
        // setToken(response.data.data.token);
        // this.getSelf();
        this.sendRegisterOtp({
          params: {
            email: this.email,
          },
          success: (res: AxiosResponse) => {
            this.$router.push({
              name: "verify-email",
              query: { redirect: "register", email: this.email },
            });
          },
          error: (err: any) => {
            console.error('Send register OTP failed:', err);
            toast.error('Failed to send verification OTP.');
          }
        });
      },
    });
  }

  private mounted() {
    const googleClientId = process.env.VUE_APP_GOOGLE_CLIENT_ID;
    if (googleClientId) {
      this.initGoogleAuth(googleClientId);
    }
  }

  private initGoogleAuth(clientId: string) {
    if (typeof (window as any).google !== 'undefined') {
      // Initialize Google Identity Services
      (window as any).google.accounts.id.initialize({
        client_id: clientId,
        callback: this.handleCredentialResponse,
        auto_prompt: true,
      });

      // Render the sign-in button
      (window as any).google.accounts.id.renderButton(
        document.getElementById('googleSignInContainer'),
        {
          type: 'icon',
          shape: 'circle',
          theme: 'filled_blue',
          size: 'large',
          width: 40,
        }
      );
    } else {
      setTimeout(() => {
        this.initGoogleAuth(clientId);
      }, 100);
    }
  }

  private handleCredentialResponse(response: any) {
    try {
      const payload = JSON.parse(atob(response.credential.split('.')[1]));
    } catch (error) {
      console.error('Error decoding JWT:', error);
    }

    // Use the same Google OAuth endpoint for registration
    // The backend should handle creating new accounts if they don't exist
    this.loginWithGoogle({
      params: {
        id_token: response.credential
      },
      success: (res: AxiosResponse) => {
        setToken(res.data.data.token);
        this.getSelf({
          success: () => {
            this.$router.push({
              name: "home",
            });
          },
          error: (err: any) => {
            console.error('Get self failed:', err);
            toast.error('Failed to retrieve user information.');
          }
        });
      },
      error: (err: any) => {
        console.error('Register with Google failed:', err);
        // Optionally show an error message to the user
      }
    });
  }
}
